import { render, staticRenderFns } from "./ForcePasswordChange.vue?vue&type=template&id=4574d8a1&"
import script from "./ForcePasswordChange.vue?vue&type=script&lang=js&"
export * from "./ForcePasswordChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4574d8a1')) {
      api.createRecord('4574d8a1', component.options)
    } else {
      api.reload('4574d8a1', component.options)
    }
    module.hot.accept("./ForcePasswordChange.vue?vue&type=template&id=4574d8a1&", function () {
      api.rerender('4574d8a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Settings/ForcePasswordChange.vue"
export default component.exports